var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.831,
    height: 26,
    viewBox: "0 0 20.831 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1039",
    "data-name": "\\uADF8\\uB8F9 1039",
    transform: "translate(-819 -451.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1028",
    "data-name": "\\uADF8\\uB8F9 1028",
    transform: "translate(819 454.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_111",
    "data-name": "\\uD0C0\\uC6D0 111",
    transform: "translate(2.149 3.034)",
    fill: "#ffb013",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.393,
    cy: 7.381,
    rx: 8.393,
    ry: 7.381,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.393,
    cy: 7.381,
    rx: 7.893,
    ry: 6.881,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M13.79,3.375A10.415,10.415,0,1,0,24.206,13.79,10.414,10.414,0,0,0,13.79,3.375Zm5.333,7.536-6.695,6.725h-.005a.9.9,0,0,1-.581.275.877.877,0,0,1-.586-.285l-2.8-2.8a.2.2,0,0,1,0-.285l.891-.891a.194.194,0,0,1,.28,0l2.223,2.223,6.109-6.154a.2.2,0,0,1,.14-.06h0a.182.182,0,0,1,.14.06l.876.906A.2.2,0,0,1,19.123,10.911Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#ffb013"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(826.916 472.375)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.59c679af10af29dbbfad6d3cb38e4c18.svg";
export { ForwardRef as ReactComponent };